import {User, UserWithEmail} from "./types";

export const isHost = (user: User, hostId : string) => {
    return user.id === hostId
}

export const isHostEmail = (user: UserWithEmail) => {
    return user.email === "superuser@xureal.com"
}